import React from 'react';
import type { SearchVacanciesHit } from '../../types';
import VacancyTeaser from '../../../VacancyTeaser';

interface Props {
  hit: SearchVacanciesHit;
  withBackground?: boolean;
}

const SearchVacanciesResultsHit: React.FC<Props> = ({ hit, withBackground }) => {
  return (
    <VacancyTeaser
      title={hit.title[0]}
      body={hit.body_summary[0]}
      nid={hit.nid[0]}
      path={hit.url[0]}
      location={hit.field_address_name?.[0]}
      employmentType={hit.field_employment_type_name[0]}
      department={hit.field_department_name[0]}
      withBackground={withBackground}
    />
  );
};

export default SearchVacanciesResultsHit;
